import { IAdminEvent } from '../store';

import { IStore } from '../../../';

export const setCurrent = async (state: IStore, event: IAdminEvent) => {
  if (state.adminEvents.current && event.id === state.adminEvents.current.id) {
    return state;
  }

  return {
    adminEvents: {
      ...state.adminEvents,
      current: event
    }
  };
};
